import { PipeTransform, Pipe } from '@angular/core';
import { enumToList } from '../enum-to-list';
import { AssignmentStatus } from '../../enums/assignment-status.enum';
import { IdName } from 'src/app/shared/models/id-name.model';

@Pipe({
  name: 'assignmentStatus',
  standalone: false
})
export class AssignmentStatusPipe implements PipeTransform {
  public transform(value: AssignmentStatus): string {
    return getAssignmentStatus(value);
  }
}

export function getAssignmentStatus(value: AssignmentStatus): string {
  switch (value) {
    case AssignmentStatus.Overdue:
      return 'Overdue';
    case AssignmentStatus.Incomplete:
      return 'Incomplete';
    case AssignmentStatus.Completed:
      return 'Completed';
    default:
      throw new Error(`Unsupported value for AssignmentStatus: ${value}.`);
  }
}

export function getAssignmentStatusList(): IdName[] {
  return enumToList(AssignmentStatus, getAssignmentStatus);
}
